export enum ComplianceHeaderText {
  COUNTRY = "country",
  BATT = "batt",
  PACK = "pack",
  WEEE = "weee",
  STREAM = "stream",
  SCHEME = "scheme",
  OVERVIEW = "overview",
  PAPER = "paper",
  PRODUCT = "product",
  SUP = "sup",
  TEXTILES = "textiles"
}
